/* Breasties theme: buy box (packs × shade × size), shade quiz, size finder,
   gallery per shade, review filters, creator videos, dispatch cut-off. */
(function () {
  if (window.__bz) return;
  window.__bz = true;
  var d = document;
  var BZ = window.BZ || { shades: [], sizes: [], oos: 'hide' };
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function closest(el, s) { return el && el.closest ? el.closest(s) : null; }
  function h(t) { return String(t == null ? '' : t).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  // "Chic Cherries (AA-A)" on the product matches "Chic Cherries" in Theme settings
  function eq(a, b) { var x = h(a), y = h(b); return !!x && !!y && (x === y || x.indexOf(y + '-') === 0 || y.indexOf(x + '-') === 0); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return window.ThemeCart && ThemeCart.money ? ThemeCart.money(c) : '£' + (c / 100).toFixed(2); }
  function shadeInfo(name) { var k = h(name); for (var i = 0; i < BZ.shades.length; i++) if (eq(BZ.shades[i].handle, k)) return BZ.shades[i]; return { name: name, handle: k, color: '#d9c3ad', desc: '' }; }
  function params() { var o = {}; location.search.replace(/^\?/, '').split('&').forEach(function (p) { var kv = p.split('='); if (kv[0]) o[decodeURIComponent(kv[0])] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')); }); return o; }

  /* ---------- London time helpers ---------- */
  function london(dt) {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, weekday: 'short' }).formatToParts(dt);
      var g = function (t) { return (p.find(function (x) { return x.type === t; }) || {}).value; };
      return { y: +g('year'), m: +g('month'), d: +g('day'), h: +g('hour') % 24, mi: +g('minute'), s: +g('second'), wd: g('weekday') };
    } catch (e) { return { y: dt.getFullYear(), m: dt.getMonth() + 1, d: dt.getDate(), h: dt.getHours(), mi: dt.getMinutes(), s: dt.getSeconds(), wd: dt.toDateString().slice(0, 3) }; }
  }
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addWorkdays(dt, n) { var x = new Date(dt); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); var w = x.getUTCDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmtDay(x) { return WD[x.getUTCDay()] + ' ' + x.getUTCDate() + ' ' + MO[x.getUTCMonth()]; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function delivery(el) {
    var cut = +el.getAttribute('data-cutoff') || 14, mn = +el.getAttribute('data-min') || 2, mx = +el.getAttribute('data-max') || mn;
    function tick() {
      var L = london(new Date());
      var day = new Date(Date.UTC(L.y, L.m - 1, L.d));
      var secs = L.h * 3600 + L.mi * 60 + L.s, left = cut * 3600 - secs, w = day.getUTCDay();
      if (w === 0 || w === 6 || left <= 0) {
        var nd = addWorkdays(day, 1);
        left += (Math.round((nd - day) / 86400000)) * 86400;
        day = nd;
      }
      var a = addWorkdays(day, mn), b = addWorkdays(day, mx);
      var hh = Math.floor(left / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
      var c = $('[data-bz-cut]', el), e = $('[data-bz-eta]', el);
      if (c) c.textContent = pad(hh) + ':' + pad(mm) + ':' + pad(ss);
      if (e) e.textContent = mn === mx ? fmtDay(a) : fmtDay(a) + ' to ' + fmtDay(b);
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- modals ---------- */
  var lastFocus = null;
  function openModal(id) {
    var m = d.getElementById(id); if (!m) return;
    lastFocus = d.activeElement;
    m.hidden = false; d.documentElement.classList.add('vb-lock');
    if (id === 'BzQuiz') quizStep(1);
    if (id === 'BzSize') sizeStep();
    setTimeout(function () { var f = $('button, [href], input', $('.bz-modal__box', m)); if (f) f.focus(); }, 30);
  }
  function closeModal(m) { m.hidden = true; d.documentElement.classList.remove('vb-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  function applyMatch(shade, size) {
    var box = $('[data-bz-buybox]');
    if (box && box.__bz) { box.__bz.applyAll(shade, size); var t = $('[data-bz-pairs]', box) || box; window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' }); return; }
    var q = []; if (shade) q.push('shade=' + h(shade)); if (size) q.push('size=' + h(size));
    location.href = (BZ.quizUrl || '/collections/all') + (q.length ? '?' + q.join('&') : '');
  }
  function cupList() {
    var out = [];
    BZ.sizes.forEach(function (z) { (z.cupList || '').split(',').forEach(function (c) { c = c.trim(); if (c && out.indexOf(c) < 0) out.push(c); }); });
    return out;
  }
  function sizeForCup(cup) { for (var i = 0; i < BZ.sizes.length; i++) { if ((BZ.sizes[i].cupList || '').split(',').map(function (x) { return x.trim(); }).indexOf(cup) > -1) return BZ.sizes[i]; } return null; }
  var quiz = {};
  function quizStep(n) {
    var body = $('[data-bz-quiz-body]'); if (!body) return;
    var A = function (k) { return esc(body.getAttribute('data-' + k)); };
    if (n === 1) {
      quiz = {};
      body.innerHTML = '<p class="bz-modal__n">Question 1 of 2</p><h3 id="BzQuizT">' + A('q1') + '</h3><div class="bz-qsw">' +
        BZ.shades.map(function (s) { return '<button type="button" data-bz-q-shade="' + esc(s.name) + '"><i style="background:' + esc(s.color) + '"></i><b>' + esc(s.name) + '</b><small>' + esc(s.desc) + '</small></button>'; }).join('') +
        '</div><p class="bz-modal__tip">' + A('q1-tip') + '</p>';
    } else if (n === 2) {
      body.innerHTML = '<p class="bz-modal__n">Question 2 of 2</p><h3 id="BzQuizT">' + A('q2') + '</h3><div class="bz-qcup">' +
        cupList().map(function (c) { return '<button type="button" data-bz-q-cup="' + esc(c) + '">' + esc(c) + '</button>'; }).join('') + '</div>';
    } else {
      var s = shadeInfo(quiz.shade), z = sizeForCup(quiz.cup) || BZ.sizes[1] || BZ.sizes[0] || { name: '' };
      quiz.size = z.name;
      body.innerHTML = '<p class="bz-modal__n">' + A('result') + '</p><div class="bz-qres"><i style="background:' + esc(s.color) + '"></i><div><h3 id="BzQuizT">' + esc(s.name) + ' · ' + esc(z.name) + '</h3><p>' + esc(z.cups || '') + (z.cm ? ' cup · ' + esc(z.cm) + ' across' : '') + '</p></div></div>' +
        '<button type="button" class="vb-btn vb-btn--pill bz-modal__go" data-bz-q-apply>' + A('apply') + '</button><button type="button" class="bz-link" data-bz-q-restart>' + A('restart') + '</button>';
    }
  }
  function sizeStep(cup) {
    var body = $('[data-bz-size-body]'); if (!body) return;
    var A = function (k) { return esc(body.getAttribute('data-' + k)); };
    var z = cup ? sizeForCup(cup) : null;
    var card = '<svg viewBox="0 0 460 140" class="bz-sizeviz" aria-hidden="true"><rect x="4" y="43" width="85.6" height="54" rx="4" fill="none" stroke="currentColor" stroke-dasharray="3 2"/><text x="46.8" y="74" text-anchor="middle" font-size="10" fill="currentColor">bank card</text>';
    var x = 104;
    BZ.sizes.forEach(function (s) { var r = (parseFloat(s.cm) || 10) * 5, on = z && z.name === s.name; card += '<circle cx="' + (x + r) + '" cy="70" r="' + r + '" fill="' + (on ? 'var(--vb-deep)' : '#fff') + '" fill-opacity="' + (on ? '.22' : '1') + '" stroke="currentColor" stroke-width="' + (on ? 2 : 1) + '"/><text x="' + (x + r) + '" y="74" text-anchor="middle" font-size="11" font-weight="700" fill="currentColor">' + esc(s.cm) + '</text>'; x += r * 2 + 10; });
    card += '</svg>';
    body.innerHTML = '<h3 id="BzSizeT">' + A('title') + '</h3><p class="bz-modal__n">' + A('q') + '</p><div class="bz-qcup">' +
      cupList().map(function (c) { return '<button type="button" data-bz-s-cup="' + esc(c) + '" aria-pressed="' + (c === cup) + '">' + esc(c) + '</button>'; }).join('') + '</div>' + card +
      (z ? '<div class="bz-qres bz-qres--size"><div><h3>' + esc(z.name) + '</h3><p>' + esc(z.cups) + ' cup · ' + esc(z.cm) + ' across · ' + esc(z.compare || '') + '</p></div></div><button type="button" class="vb-btn vb-btn--pill bz-modal__go" data-bz-s-apply="' + esc(z.name) + '">' + A('apply') + '</button>' : '') +
      '<p class="bz-modal__tip">' + A('tip') + '</p>';
  }

  /* ---------- buy box ---------- */
  function Box(sec) {
    var box = $('[data-bz-buybox]', sec), json = $('[data-bz-json]', sec);
    if (!box || !json || box.__bz) return;
    var P = JSON.parse(json.textContent);
    var V = P.variants;
    var hasShade = V.some(function (v) { return v.shade; }), hasSize = V.some(function (v) { return v.size; });
    // shades/sizes in the order set in Theme settings, then any extras from the product
    var names = function (key, list) {
      var vals = []; V.forEach(function (v) { if (v[key] && vals.indexOf(v[key]) < 0) vals.push(v[key]); });
      var out = []; list.forEach(function (x) { vals.forEach(function (n) { if (eq(n, x.handle) && out.indexOf(n) < 0) out.push(n); }); });
      vals.forEach(function (n) { if (out.indexOf(n) < 0) out.push(n); });
      return out;
    };
    var SH = hasShade ? names('shade', BZ.shades) : [null], SZ = hasSize ? names('size', BZ.sizes) : [null];
    var mode = BZ.oos || 'hide';
    var pick = $('[data-bz-pairs]', box), sameWrap = $('[data-bz-same-wrap]', box), same = $('[data-bz-same]', box);
    var packs = $$('[data-bz-pack]', box), addon = $('[data-bz-addon]', box), addonJ = $('[data-bz-addon-json]', box);
    var AV = addonJ ? JSON.parse(addonJ.textContent).variants : [];
    var atc = $('[data-bz-atc]', box), err = $('[data-bz-err]', box);
    var st = { pairs: 1, pct: 0, same: true, picks: [] };
    var pk = packs.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || packs[0];
    if (pk) { st.pairs = +pk.getAttribute('data-pairs') || 1; st.pct = +pk.getAttribute('data-pct') || 0; }

    function find(s, z) { for (var i = 0; i < V.length; i++) { if ((!hasShade || V[i].shade === s) && (!hasSize || V[i].size === z)) return V[i]; } return null; }
    function buyable(v) { return !!(v && v.available); }
    function shown(v) { return mode !== 'hide' || buyable(v); }
    function nearest(s, z) {
      var i = SH.indexOf(s); if (i < 0) i = 0;
      for (var k = 1; k < SH.length; k++) {
        var a = SH[i + k], b = SH[i - k];
        if (a !== undefined && buyable(find(a, z))) return a;
        if (b !== undefined && buyable(find(b, z))) return b;
      }
      return null;
    }
    function defaultPick() {
      var fv = null;
      if (P.defShade || P.defSize) V.forEach(function (v) { if (!fv && buyable(v) && (!P.defShade || !v.shade || eq(v.shade, P.defShade)) && (!P.defSize || !v.size || eq(v.size, P.defSize))) fv = v; });
      fv = fv || V.filter(buyable)[0] || V[0];
      return { want: fv ? fv.shade : null, shade: fv ? fv.shade : null, size: fv ? fv.size : null, swapped: false };
    }
    function resolve(p) {
      // keep what the shopper asked for (want); if hidden as sold out, use the nearest in-stock shade
      p.shade = p.want; p.swapped = false;
      if (mode === 'hide' && hasShade && !buyable(find(p.want, p.size))) {
        var n = nearest(p.want, p.size);
        if (n) { p.shade = n; p.swapped = true; }
        else {
          // nothing in this size: try other sizes with the wanted shade
          for (var j = 0; j < SZ.length; j++) if (buyable(find(p.want, SZ[j]))) { p.size = SZ[j]; break; }
        }
      }
    }
    function sync() {
      while (st.picks.length < st.pairs) st.picks.push(JSON.parse(JSON.stringify(st.picks[0] || defaultPick())));
      st.picks.length = st.pairs;
      if (st.same) for (var i = 1; i < st.picks.length; i++) { st.picks[i].want = st.picks[0].want; st.picks[i].size = st.picks[0].size; }
      st.picks.forEach(resolve);
    }
    function renderPicks() {
      if (!pick) return;
      if (sameWrap) sameWrap.hidden = st.pairs < 2;
      var rows = st.same ? 1 : st.pairs;
      var html = '';
      for (var i = 0; i < rows; i++) {
        var p = st.picks[i];
        html += '<div class="bz-pr">' + (rows > 1 ? '<p class="bz-pr__n">Pair ' + (i + 1) + '</p>' : '');
        if (hasShade) {
          var info = shadeInfo(p.shade);
          html += '<p class="bz-pr__l">' + esc(pick.getAttribute('data-shade-label')) + ': <b>' + esc(p.shade) + '</b>' + (info.desc ? ' <span>' + esc(info.desc) + '</span>' : '') + '</p><div class="bz-sw" role="radiogroup" aria-label="' + esc(pick.getAttribute('data-shade-label')) + '">';
          SH.forEach(function (s) {
            var v = find(s, p.size); if (!v) return;
            if (!shown(v)) return;
            var si = shadeInfo(s), out = !buyable(v), pre = buyable(v) && v.preorder && mode === 'preorder';
            html += '<button type="button" role="radio" aria-checked="' + (s === p.shade) + '" data-bz-pick-shade="' + esc(s) + '" data-i="' + i + '" title="' + esc(s) + (out ? ' (sold out)' : pre ? ' (pre-order)' : '') + '"' + (out ? ' disabled' : '') + ' class="' + (out ? 'is-out' : '') + '"><i style="background:' + esc(si.color) + '"></i><span>' + esc(s) + '</span>' + (pre ? '<em>Pre-order</em>' : si.rare && BZ.rareLabel ? '' : '') + '</button>';
          });
          html += '</div>';
        }
        if (hasSize) {
          html += '<p class="bz-pr__l">' + esc(pick.getAttribute('data-size-label')) + ': <b>' + esc(p.size) + '</b></p><div class="bz-sz" role="radiogroup" aria-label="' + esc(pick.getAttribute('data-size-label')) + '">';
          SZ.forEach(function (z) {
            var zi = null; BZ.sizes.forEach(function (x) { if (eq(z, x.handle)) zi = x; });
            var anyOk = SH.some(function (s) { return buyable(find(s, z)); });
            var out = mode === 'soldout' ? !buyable(find(p.want, z)) && !anyOk : !anyOk;
            html += '<button type="button" role="radio" aria-checked="' + (z === p.size) + '" data-bz-pick-size="' + esc(z) + '" data-i="' + i + '"' + (out ? ' disabled class="is-out"' : '') + '><b>' + esc(zi ? String(z).replace(/\s*\([^)]*\)\s*$/, '') : z) + '</b>' + (zi ? '<small>' + esc(zi.cups) + ' · ' + esc(zi.cm) + '</small>' : '') + '</button>';
          });
          html += '</div>';
        }
        if (p.swapped) {
          var msg = (pick.getAttribute('data-restock') || '').replace('{shade}', esc(p.want)).replace('{nearest}', '<b>' + esc(p.shade) + '</b>');
          var nt = (pick.getAttribute('data-notify') || '').replace('{shade}', esc(p.want));
          html += '<p class="bz-oos">' + msg + (BZ.notify && nt ? ' <a href="' + esc(BZ.notify) + '">' + nt + '</a>' : '') + '</p>';
        }
        html += '</div>';
      }
      pick.innerHTML = html;
    }
    function lineVariants() { return st.picks.map(function (p) { return find(p.shade, p.size); }); }
    function addonVariant() {
      if (!AV.length) return null;
      var p = st.picks[0] || {}, best = null;
      AV.forEach(function (v) { if (best) return; if (v.available && (!p.shade || v.options.indexOf(p.shade) > -1) && (!p.size || v.options.indexOf(p.size) > -1)) best = v; });
      return best || AV.filter(function (v) { return v.available; })[0] || null;
    }
    function addonPrice() {
      if (!addon || !addon.checked) return 0;
      var t = (closest(addon, '.bz-addon').querySelector('.bz-addon__p b') || {}).textContent || '';
      var m = t.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      return m ? Math.round(parseFloat(m[1]) * 100) : 0;
    }
    function totals(n, pct) {
      var vs = lineVariants(), base = vs[0] || V[0], sum = 0, cmp = 0;
      for (var i = 0; i < n; i++) { var v = vs[i] || base; sum += v.price; cmp += Math.max(v.compare || 0, v.price); }
      var tot = Math.round(sum * (1 - pct / 100));
      return { total: tot, compare: cmp, each: Math.round(tot / n) };
    }
    function render() {
      sync(); renderPicks();
      var t = totals(st.pairs, st.pct), add = addonPrice(), grand = t.total + add;
      var tot = $('[data-bz-total]', box), cmp = $('[data-bz-compare]', box), sv = $('[data-bz-save]', box);
      if (tot) tot.textContent = money(t.total);
      if (cmp) { cmp.hidden = !(t.compare > t.total); cmp.textContent = money(t.compare); }
      if (sv) { var save = t.compare - t.total; sv.hidden = !(save > 0); sv.textContent = (sv.getAttribute('data-tpl') || '').replace('{saving}', money(save)); }
      packs.forEach(function (b) {
        var n = +b.getAttribute('data-pairs') || 1, pc = +b.getAttribute('data-pct') || 0, pt = totals(n, pc);
        var pp = $('[data-bz-pack-price]', b), pe = $('[data-bz-pack-each]', b);
        if (pp) pp.innerHTML = money(pt.total) + (pt.compare > pt.total ? ' <s>' + money(pt.compare) + '</s>' : '');
        if (pe) pe.textContent = n > 1 ? (pe.getAttribute('data-tpl') || '').replace('{each}', money(pt.each)) : '';
      });
      var vs = lineVariants(), ok = vs.every(buyable), pre = ok && vs.some(function (v) { return v.preorder && mode === 'preorder'; });
      if (atc) {
        atc.disabled = !ok;
        atc.textContent = (!ok ? atc.getAttribute('data-none') : (pre ? atc.getAttribute('data-pre') : atc.getAttribute('data-label'))).replace('{price}', money(grand));
      }
      var xp = $('[data-bz-xpay]', box);
      if (xp) {
        var one = vs.every(function (v) { return v && vs[0] && v.id === vs[0].id; }) && !(addon && addon.checked) && ok;
        xp.hidden = !one;
        var xid = $('[data-bz-xid]', box), xq = $('[data-bz-xqty]', box);
        if (xid && vs[0]) xid.value = vs[0].id;
        if (xq) xq.value = st.pairs;
      }
      // product switcher keeps shade/size/pairs
      $$('[data-bz-type-link]', box).forEach(function (a) {
        var u = a.getAttribute('href').split('?')[0], p = st.picks[0] || {};
        var q = []; if (p.shade) q.push('shade=' + h(p.want || p.shade)); if (p.size) q.push('size=' + h(p.size)); if (st.pairs > 1) q.push('pairs=' + st.pairs);
        a.setAttribute('href', u + (q.length ? '?' + q.join('&') : ''));
      });
      gallery(sec, st.picks[0] && st.picks[0].shade, lineVariants()[0]);
      var sub = $('[data-bz-satc-sub]', sec), dot = $('[data-bz-satc-dot]', sec);
      if (sub) sub.textContent = [st.pairs + (st.pairs > 1 ? ' pairs' : ' pair'), st.same && st.picks[0] ? [st.picks[0].shade, st.picks[0].size].filter(Boolean).join(' · ') : 'mixed', money(grand)].join(' · ');
      if (dot && st.picks[0]) dot.style.background = shadeInfo(st.picks[0].shade).color;
      var sImg = $('[data-bz-satc-img]', sec);
      if (sImg) {
        var v0 = lineVariants()[0], src = (v0 && v0.img) || '';
        if (!src) { var vis = $$('.bz-gal__slide', sec).filter(function (s) { return !s.hidden; })[0], im = vis && vis.querySelector('img'); src = im ? (im.currentSrc || im.src) : (P.image || ''); }
        if (src && sImg.getAttribute('src') !== src) { sImg.src = src; sImg.hidden = false; }
      }
    }
    function add(btn) {
      var vs = lineVariants(); if (!vs.every(buyable)) return;
      var map = {}, order = [];
      vs.forEach(function (v) { if (!map[v.id]) { map[v.id] = 0; order.push(v.id); } map[v.id]++; });
      var items = order.map(function (id) { return { id: id, quantity: map[id] }; });
      var av = addon && addon.checked ? addonVariant() : null;
      if (av) items.push({ id: av.id, quantity: 1 });
      if (err) err.hidden = true;
      btn.classList.add('is-busy'); btn.disabled = true;
      var done = function () { btn.classList.remove('is-busy'); btn.disabled = false; };
      if (!window.ThemeCart) { location.href = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(','); return; }
      ThemeCart.add(items, P.afterAdd || 'drawer', false).then(done, function (e) {
        done(); if (err) { err.textContent = (e && (e.description || e.message)) || 'Sorry, something went wrong. Please try again.'; err.hidden = false; }
      });
    }
    // deep links: ?shade=toffee&size=peach-perfect&pairs=2
    var q = params(), first = defaultPick();
    if (q.shade && hasShade) SH.forEach(function (s) { if (eq(s, q.shade)) first.want = s; });
    if (q.size && hasSize) SZ.forEach(function (z) { if (eq(z, q.size)) first.size = z; });
    if (q.pairs) packs.forEach(function (b) { if (+b.getAttribute('data-pairs') === +q.pairs) { pk = b; st.pairs = +q.pairs; st.pct = +b.getAttribute('data-pct') || 0; } });
    packs.forEach(function (b) { b.setAttribute('aria-checked', b === pk); });
    st.picks = [first];

    box.addEventListener('click', function (e) {
      var el;
      if ((el = closest(e.target, '[data-bz-pack]'))) {
        packs.forEach(function (b) { b.setAttribute('aria-checked', b === el); });
        st.pairs = +el.getAttribute('data-pairs') || 1; st.pct = +el.getAttribute('data-pct') || 0; render(); return;
      }
      if ((el = closest(e.target, '[data-bz-pick-shade]'))) { var i = +el.getAttribute('data-i'); st.picks[i].want = el.getAttribute('data-bz-pick-shade'); render(); return; }
      if ((el = closest(e.target, '[data-bz-pick-size]'))) { var j = +el.getAttribute('data-i'); st.picks[j].size = el.getAttribute('data-bz-pick-size'); render(); return; }
      if ((el = closest(e.target, '[data-bz-atc]'))) { add(el); return; }
    });
    if (same) same.addEventListener('change', function () { st.same = same.checked; render(); });
    if (addon) addon.addEventListener('change', render);
    var satcBtn = $('[data-bz-satc-btn]', sec);
    if (satcBtn) satcBtn.addEventListener('click', function () { add(satcBtn); });
    var satc = $('[data-bz-satc]', sec);
    if (satc && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        satc.classList.toggle('is-on', on); satc.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (satcBtn) satcBtn.tabIndex = on ? 0 : -1;
      }).observe(atc);
    }
    box.__bz = {
      applyAll: function (shade, size) {
        st.same = true; if (same) same.checked = true;
        var s0 = null, z0 = null;
        SH.forEach(function (s) { if (shade && eq(s, shade)) s0 = s; });
        SZ.forEach(function (z) { if (size && eq(z, size)) z0 = z; });
        st.picks.forEach(function (p) { if (s0) p.want = s0; if (z0) p.size = z0; });
        render();
      }
    };
    render();
  }

  /* ---------- gallery: filter by shade (photo alt text) ---------- */
  function fileOf(u) { return String(u || '').split('?')[0].split('/').pop().toLowerCase(); }
  function gallery(sec, shade, v) {
    var g = $('[data-bz-gallery]', sec); if (!g) return;
    var k = h(shade), slides = $$('.bz-gal__slide', g), thumbs = $$('[data-bz-gal-go]', g);
    var tr = $('[data-bz-gal-track]', g);
    var ph = $('[data-bz-ph-cover]', g); if (ph && shade) ph.style.background = shadeInfo(shade).color;
    var moved = false;
    if (g.__shade !== k) {
      g.__shade = k; moved = true;
      var match = function (el) { return k && (el.getAttribute('data-alt') || '').indexOf(k) > -1; };
      var any = slides.some(match);
      slides.forEach(function (s) { s.hidden = any && !match(s) && (s.getAttribute('data-alt') || '') !== '' && shadeTagged(s); });
      thumbs.forEach(function (t, i) { t.hidden = slides[i] ? slides[i].hidden : false; });
    }
    // show the selected variant's own photo, else the first photo when the shade changed
    var f = v && fileOf(v.img), sl = null;
    if (f && g.__vimg !== f) {
      g.__vimg = f;
      sl = slides.filter(function (s) { var im = s.querySelector('img'); return !s.hidden && im && fileOf(im.getAttribute('src')) === f; })[0] || null;
    }
    if (!tr || (!sl && !moved)) return;
    var jump = function () {
      var x = sl ? sl.offsetLeft - tr.offsetLeft : 0;
      var old = tr.style.scrollBehavior; tr.style.scrollBehavior = 'auto'; tr.scrollLeft = x; tr.style.scrollBehavior = old;
      galState(g);
    };
    if (!tr.clientWidth) setTimeout(jump, 60); else jump();
  }
  function thumbsInit() { $$('[data-bz-gallery]').forEach(function (g) { thumbNav(g); }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', thumbsInit); else setTimeout(thumbsInit, 0);
  window.addEventListener('load', thumbsInit);
  d.addEventListener('shopify:section:load', thumbsInit);
  function shadeTagged(el) { var a = el.getAttribute('data-alt') || ''; return BZ.shades.some(function (s) { return a.indexOf(s.handle) > -1; }); }
  function galState(g) {
    var tr = $('[data-bz-gal-track]', g); if (!tr) return;
    var vis = $$('.bz-gal__slide', g).filter(function (s) { return !s.hidden; });
    var i = tr.clientWidth ? Math.round(tr.scrollLeft / tr.clientWidth) : 0, cur = vis[i];
    $$('[data-bz-gal-go]', g).forEach(function (t) {
      var sl = $$('.bz-gal__slide', g)[+t.getAttribute('data-bz-gal-go')], on = sl === cur;
      t.classList.toggle('is-active', on);
      if (on) { var th = t.parentNode; if (t.offsetLeft < th.scrollLeft || t.offsetLeft + t.offsetWidth > th.scrollLeft + th.clientWidth) th.scrollTo({ left: t.offsetLeft - (th.clientWidth - t.offsetWidth) / 2 }); }
    });
    thumbNav(g);
  }
  /* thumbnail strip: arrows + edge fades only when there are more photos to scroll to */
  function thumbNav(g) {
    var st = $('[data-bz-gal-strip]', g), th = $('[data-bz-gal-thumbs]', g); if (!st || !th) return;
    var max = th.scrollWidth - th.clientWidth - 2, prev = th.scrollLeft > 2, next = th.scrollLeft < max;
    st.classList.toggle('has-prev', prev); st.classList.toggle('has-next', next);
    var p = $('[data-bz-thumbs-nav="-1"]', st), n = $('[data-bz-thumbs-nav="1"]', st);
    if (p) p.hidden = !prev; if (n) n.hidden = !next;
    if (!th.__bzNav) { th.__bzNav = 1; th.addEventListener('scroll', function () { thumbNav(g); }, { passive: true }); window.addEventListener('resize', function () { thumbNav(g); }); }
  }

  /* ---------- clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = closest(t, '[data-bz-quiz-open]'))) { e.preventDefault(); openModal('BzQuiz'); return; }
    if ((el = closest(t, '[data-bz-size-open]'))) { e.preventDefault(); openModal('BzSize'); return; }
    if ((el = closest(t, '[data-bz-modal-close]'))) { closeModal(closest(el, '[data-bz-modal]')); return; }
    if ((el = closest(t, '[data-bz-q-shade]'))) { quiz.shade = el.getAttribute('data-bz-q-shade'); quizStep(2); return; }
    if ((el = closest(t, '[data-bz-q-cup]'))) { quiz.cup = el.getAttribute('data-bz-q-cup'); quizStep(3); return; }
    if ((el = closest(t, '[data-bz-q-restart]'))) { quizStep(1); return; }
    if ((el = closest(t, '[data-bz-q-apply]'))) { closeModal(d.getElementById('BzQuiz')); applyMatch(quiz.shade, quiz.size); return; }
    if ((el = closest(t, '[data-bz-s-cup]'))) { sizeStep(el.getAttribute('data-bz-s-cup')); return; }
    if ((el = closest(t, '[data-bz-s-apply]'))) { closeModal(d.getElementById('BzSize')); applyMatch(null, el.getAttribute('data-bz-s-apply')); return; }
    if ((el = closest(t, '[data-bz-thumbs-nav]'))) {
      var ts = $('[data-bz-gal-thumbs]', closest(el, '[data-bz-gal-strip]'));
      if (ts) ts.scrollBy({ left: (+el.getAttribute('data-bz-thumbs-nav')) * ts.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    if ((el = closest(t, '[data-bz-gal-go]'))) {
      var g = closest(el, '[data-bz-gallery]'), tr = $('[data-bz-gal-track]', g), sl = $$('.bz-gal__slide', g)[+el.getAttribute('data-bz-gal-go')];
      if (tr && sl) tr.scrollTo({ left: sl.offsetLeft - tr.offsetLeft, behavior: 'smooth' });
      return;
    }
    if ((el = closest(t, '[data-bz-play]'))) {
      var r = closest(el, '[data-bz-reel]'), v = $('video', r);
      $$('[data-bz-reel].is-playing').forEach(function (o) { if (o !== r) { o.classList.remove('is-playing'); var ov = $('video', o); if (ov) ov.pause(); } });
      if (v) { if (v.paused) { v.muted = false; v.play(); r.classList.add('is-playing'); } else { v.pause(); r.classList.remove('is-playing'); } }
      return;
    }
    if ((el = closest(t, '[data-bz-filter] [data-f]'))) {
      var grp = closest(el, '[data-bz-filter]'), f = el.getAttribute('data-f'), sec = closest(grp, 'section');
      $$('[data-f]', grp).forEach(function (b) { b.setAttribute('aria-pressed', b === el); });
      $$('.bz-rev', sec).forEach(function (rv) { rv.hidden = !!f && (' ' + rv.getAttribute('data-tags') + ' ').indexOf(' ' + f + ' ') < 0; });
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('[data-bz-modal]:not([hidden])').forEach(closeModal); });

  /* ---------- init ---------- */
  function init(scope) {
    scope = scope || d;
    $$('[data-bz-product]', scope).forEach(Box);
    $$('[data-bz-delivery]', scope).forEach(function (el) { if (!el.__bz) { el.__bz = 1; delivery(el); } });
    $$('[data-bz-gal-track]', scope).forEach(function (tr) {
      if (tr.__bz) return; tr.__bz = 1; var to;
      tr.addEventListener('scroll', function () { clearTimeout(to); to = setTimeout(function () { galState(closest(tr, '[data-bz-gallery]')); }, 60); }, { passive: true });
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
